import { getCurrentScript } from './lib/DOM/Script';
import { indexCommon } from './indexCommon';

const currentScript = getCurrentScript();

indexCommon(currentScript);
